export default "__VITE_ASSET__QpaXobmm__"